<template>
  <div class="tresult-table" ref="table">
    <el-badge
      v-if="mobileMode"
      :value="quantityFilters"
      :hidden="!quantityFilters"
    >
      <button
        class="tresult-table__show-filter-btn"
        @click="showFilters = !showFilters"
      >
        <i class="fas fa-filter"></i>
      </button>
    </el-badge>
    <transition name="hide">
      <filters values: ref="filters" v-if="showFilters || !mobileMode"
      :mobileMode="mobileMode" :fetchCb="fethTresults" :typeWork="works"
      :groupList="groups" />
    </transition>
    <div class="table" v-if="!mobileMode">
      <div class="row row-header">
        <div class="col" v-for="(header, index) of headers" :key="index">
          <span>{{ header }}</span>
        </div>
      </div>
      <div class="table-list">
        <div class="row" v-for="(result, index) of tresults" :key="index">
          <div class="col">
            <span>{{ result.user.group.name }}</span>
          </div>
          <div class="col">
            <span>{{ result.user.name }}</span>
          </div>
          <div class="col">
            <template v-if="result.double">
              <el-tooltip
                effect="light"
                content="Эта работа является дубликатом"
                placement="bottom"
              >
                <div>
                  <i class="el-icon-warning"></i>
                  <span v-if="result.result">
                    {{ result.result }}
                  </span>
                </div>
              </el-tooltip>
            </template>
            <template v-else>
              <span>{{ result.result }}</span>
            </template>
          </div>
          <div class="col">
            <span>{{ result.work.name }}</span>
          </div>
          <div class="col">
            <el-checkbox
              :class="{ 'is-returned': setStatusCheck(result) }"
              :value="Boolean(result.tdatetime)"
            ></el-checkbox>
          </div>

          <div class="col col-date">
            <span>{{ dateCorrector(result.datetime) }}</span>
            <span>{{ timeCorrector(result.datetime) }}</span>
          </div>
          <div class="col col-date">
            <span>{{ dateCorrector(result.tdatetime) }}</span>
            <span>{{ timeCorrector(result.tdatetime) }}</span>
          </div>
          <div class="col">
            <a
              v-if="!checkURl(result.upload)"
              :href="result.upload"
              title="Скачать работу"
              download
              target="blank"
              ><i class="el-icon-download"></i
            ></a>
            <a
              v-else
              :href="result.upload"
              target="blank"
              title="Просмотреть видео"
              ><i class="fas fa-film"></i
            ></a>
          </div>
          <div class="col" title="Редактировать">
            <button @click="modalTresultShow(result)">
              <i class="far fa-edit"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row-footer">
        <el-pagination
          layout="prev, pager, next"
          @current-change="numberClick"
          :page-size="pagination.stepResults"
          :total="pagination.quntityResults"
        >
        </el-pagination>
      </div>
    </div>
    <slider
      v-if="mobileMode"
      @next="updateCurrentSlide"
      @prev="updateCurrentSlide"
      ref="slider"
      :closeBtn="false"
    >
      <div
        class="slide__container"
        v-for="(result, index) of tresults"
        :key="index"
      >
        <div class="slide">
          <div class="slide__header">
            <button
              :class="[
                'header__arrow-btn',
                { 'arrow-disble': curentSlide === 0 },
              ]"
              @click.stop="prev"
            >
              <i class="el-icon-arrow-left"></i>
            </button>
            <span>{{ result.user.name }}</span>
            <button
              :class="[
                'header__arrow-btn',
                { 'arrow-disble': curentSlide === tresults.length - 1 },
              ]"
              @click.stop="next"
            >
              <i class="el-icon-arrow-right"></i>
            </button>
          </div>
          <div class="slide__headers">
            <span>Группа</span>
            <span>Оценка</span>
            <span>Тип работы</span>
            <span>Проверена</span>
            <span>Дата отправки</span>
            <span>Дата проверки</span>
            <span>Скачать работу</span>
          </div>
          <div class="slide__data">
            <span>{{ result.user.group.name }}</span>
            <span>{{ result.result }}</span>
            <span>{{ result.work.name }}</span>
            <el-checkbox :value="Boolean(result.done)"></el-checkbox>
            <div class="col-date">
              <span>{{ dateCorrector(result.datetime) }}</span>
              <span>{{ timeCorrector(result.datetime) }}</span>
            </div>
            <div class="col-date">
              <span>{{ dateCorrector(result.tdatetime) }}</span>
              <span>{{ timeCorrector(result.tdatetime) }}</span>
            </div>
            <div>
              <!-- <a v-if="checkURl(result.upload)" :href="`${enterPoint.downloadLink}/uploads/mgok/upload.php?name=${result.upload}`" download target="blank"><i class="el-icon-download"></i></a>
                        <a v-else href="#">link</a> -->
            </div>
          </div>
          <div class="slide__data-btn">
            <button @click="modalTresultShow(result)">
              Поставить оценку<i class="far fa-edit"></i>
            </button>
          </div>
        </div>
      </div>
    </slider>
  </div>
</template>

<script>
import slider from "@/components/slider";
import { mapMutations } from "vuex";
import filters from "../tresultView/filters";
export default {
  data() {
    return {
      curentSlide: 0,
      downloadPath: "",
      resultList: [],
      works: [],
      groups: [],
      showFilters: false,
      tresults: [],
      headers: [
        "Группа",
        "Студент",
        "Оценка",
        "Тип работы",
        "Проверена",
        "Дата отправки",
        "Дата проверки",
      ],
      pagination: {
        currentPage: 1,
        quntityResults: 0,
        stepResults: 20,
        intervalMin: 0,
        intervalMax: 7,
      },
    };
  },
  components: {
    filters,
    slider,
  },
  computed: {
    enterPoint() {
      return this.$store.state.enterPoint;
    },
    mobileMode() {
      return this.$store.state.mobileMode;
    },
    statefilters() {
      return this.$refs["filters"].preparationForm();
    },
    quantityFilters() {
      return Object.keys(this.filters).length;
    },
    transFilterFunc() {
      if (this.showFilters) {
        return "translateX(0)";
      } else {
        return "translateX(100%)";
      }
    },
    linkNextPage() {
      return (
        `api/results/${this.$route.params.did}/wresults/?page=` +
        this.pagination.currentPage
      );
    },
  },
  methods: {
    ...mapMutations(["setModalData", "setActiveFilters"]),
    setStatusCheck(result) {
      if (result.vkr_id) return result.check && !result.done;
      return result.tdatetime && !result.done;
    },
    updateCurrentSlide(v) {
      this.curentSlide = v;
    },
    next() {
      this.$refs.slider.next();
    },
    prev() {
      this.$refs.slider.prev();
    },
    modalTresultShow(value) {
      value.resultList = this.resultList;
      let obj = {
        name: "tresultEdit",
        data: {
          cb: this.fethTresults,
          value,
        },
      };

      this.setModalData(obj);
    },
    dateCorrector(value) {
      return this.globalFunctions.dateCorrector(value);
    },
    timeCorrector(value) {
      return this.globalFunctions.timeCorrector(value);
    },
    fethTresults(path, obj) {
      this.axios.get(path, obj ? { params: obj } : "").then((res) => {
        this.downloadPath = res.data.downloadPath;
        this.tresults = res.data.results.data;
        this.groups = res.data.groups;
        this.works = res.data.work;
        this.pagination.quntityResults = res.data.results.total;
        this.resultList = res.data.resultsList;
        this.$emit("loaded", res.data.discipline_name);
      });
    },
    numberClick(value) {
      this.pagination.currentPage = value;
      this.fethTresults(this.linkNextPage, this.statefilters);
    },
    checkURl(value) {
      let reResult = value.match("www.youtube.com");
      return Boolean(reResult);
    },
  },
  mounted() {
    this.fethTresults(
      `api/results/${this.$route.params.did}/wresults`,
      this.statefilters
    );
  },
};
</script>

<style lang="scss">
.tresult-table {
  position: relative;
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  overflow-y: hidden;
  .el-icon-warning {
    &:hover {
      color: $warning-clr !important;
    }
  }
  .tresult-table__show-filter-btn {
    i {
      transition-property: color;
      transition-delay: 0.3s;
      font-size: 20px;
      color: $brand-clr-1;
      &:hover {
        color: lighten($color: $brand-clr-1, $amount: 10%);
      }
    }
  }
  .el-badge {
    position: absolute;
    top: -40px;
    right: 0;
  }
  .table {
    height: 100%;
    position: relative;
    display: grid;
    grid-template-rows: max-content 1fr max-content;
    position: relative;
    width: 100%;
    color: $regular-text-clr;
    overflow: hidden;
    .table-list {
      overflow-y: auto;
      padding-bottom: 32px;
    }
    .row {
      width: 100%;
      display: grid;
      grid-template-columns: 14% 11% 13% 17% 10% 10% 12% 3% 3%;
      grid-template-rows: auto;
      justify-items: center;
      align-items: center;
      border-bottom: 1px solid $placeholder-text-clr;
      color: inherit;
    }
    .row-header {
      font-weight: bold;
      background-color: $basic-white;
      padding-right: 5px;
    }
    .col {
      color: inherit;
      text-align: center;
      i {
        transition-property: color;
        transition-duration: 0.3s;
        color: $regular-text-clr;
        cursor: pointer;
        font-size: 18px;
        &:hover {
          color: $brand-clr-1;
        }
      }
    }
    .is-returned {
      .el-checkbox__inner {
        border-color: $warning-clr;
        background-color: $warning-clr;
      }
    }
  }
  .col-date {
    display: grid;
    row-gap: 5px;
    grid-template-rows: 1fr 1fr;
  }
  .row-footer {
    width: 100%;
    height: 32px;
  }
  .el-pagination {
    background-color: $basic-white;
    width: 100%;
  }
  .slide {
    display: grid;
    grid-template-areas:
      "header header"
      "headers data"
      "btn btn";
    grid-template-columns: 1fr 1fr;
  }
  .slide__header {
    display: grid;
    grid-template-columns: 20px 1fr 20px;
    width: 100%;
    padding: 10px 5px;
    background-color: $brand-clr-1;
    color: $basic-white;
    justify-self: center;
    grid-area: header;
    text-align: center;
  }
  .header__arrow-btn {
    font-weight: bold;
    color: $basic-white;
    padding: 0;
    i {
      font-size: 20px;
      font-weight: inherit;
    }
  }
  .arrow-disble {
    color: $primary-text-clr;
  }
  .slide__headers {
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(7, 1fr);
    align-items: center;
    font-weight: bold;
    grid-area: headers;
    span {
      font-size: 13px;
    }
  }
  .slide__data {
    grid-area: data;
    justify-items: center;
    align-items: center;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(7, 1fr);
    span {
      text-align: center;
      font-size: 13px;
    }
    i {
      font-size: 25px;
      color: $brand-clr-1;
    }
  }
  .slide__data-btn {
    grid-area: btn;
    padding: 10px;
    button {
      background-color: $brand-clr-1;
      width: max-content;
      justify-self: center;
      padding: 10px;
      border-radius: 5px;
      color: $basic-white;
      display: flex;
      margin: 0 auto;
      align-items: center;
      i {
        margin-left: 10px;
      }
    }
  }
}
.hide-enter-active,
.hide-leave-active {
  transition-duration: 0.3s;
}
.hide-enter,
.hide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
@media (max-width: 800px) {
  .tresult-table {
    margin-top: 10px;
  }
}
</style>
